import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-chart-doughnut',
  templateUrl: './chart-doughnut.component.html',
  styleUrls: ['./chart-doughnut.component.css']
})
export class ChartDoughnutComponent implements OnInit {
  @Input() doughnutChartLabels:any;
  @Input() doughnutChartData:any;
  @Input() backgroundColor:any;
  @Input() borderColor:any;
  @Input() label:any;
  @Input() progressText:any;
  
  doughnutChartDatasets!: ChartConfiguration<'doughnut'>['data']['datasets'];
  doughnutChartOptions!: ChartConfiguration<'doughnut'>['options'];
  
  constructor() {}

  ngOnInit(): void {
    this.doughnutChartDatasets = [
      { data: this.doughnutChartData, 
        backgroundColor: this.backgroundColor,
        borderColor: this.borderColor,
        label: this.label
      }
    ];

    this.doughnutChartOptions = { responsive: true };
  }

}
